import type { HotelIngredient } from '@apps/main/modules/recipe/ingredients';

import type { IngredientSerializer } from '../..';

import { serializeHotel } from './serialize';
import { deserializeHotel } from './deserialize';

export const HotelSerializer: IngredientSerializer<HotelIngredient> = {
  serialize: (hotel: HotelIngredient): string => serializeHotel(hotel),
  deserialize: (value: string): HotelIngredient => deserializeHotel(value),
};

export { HOTEL_INGREDIENT_SUFFIX } from './constants';
export { deserializeConstraintText } from './deserialize';
